import { render, staticRenderFns } from "./CollaboratorEditModal.vue?vue&type=template&id=7887036d"
import script from "./CollaboratorEditModal.vue?vue&type=script&lang=js"
export * from "./CollaboratorEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports